const ColGroupPortfolio = () => (
    <colgroup>
        <col style={{width: "15%"}}/>
        {/* Stocks */}
        <col style={{width: "13%"}}/>
        {/* Today's Gain */}
        <col style={{width: "15.9%"}}/>
        {/* Overall Gain */}
        <col style={{width: "0.1%"}}/>
        {/* empty */}
        <col style={{width: "16.5%"}}/>
        {/* Current Value */}
        <col style={{width: "14%"}}/>
        {/* Quantity */}
        <col style={{width: "14.5%"}}/>
        {/* Invested */}
        <col style={{width: "11%"}}/>
        {/* Price */}
    </colgroup>
);

export default ColGroupPortfolio;
